// extracted by mini-css-extract-plugin
var _1 = "EmailCreationFormMassMailingCheckbox-moduleEmailCreationFormMassMailingCheckbox__wYYWm";
export { _1 as "EmailCreationFormMassMailingCheckbox" }
